import { base_url } from "../config/config";
import axios from "axios";

const fetchDataFromLink = async (link, data) => {
  try {
    const response = await axios.post(link, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = response.data;
    return [result, response.status];
  } catch (error) {
    return [error["response"]["data"]["error"], error["response"]["status"]];
  }
};

export const registerLanding_api = async (name, phone) => {
  const formData = {
    name: name,
    phone: phone,
  };
  const data = await fetchDataFromLink(
    `${base_url}/gateway/register_landing`,
    formData
  );
  return data;
};

export default registerLanding_api;
